import React from 'react'
import ArchFull from '@assets/images/Tooth/ArchFull.svg'
import ArchUpper from '@assets/images/Tooth/ArchUpper.svg'
import ArchLower from '@assets/images/Tooth/ArchLower.svg'

export type ChartingView = 'full' | 'upper' | 'lower'

interface ChartingViewToggleProps {
  currentView: ChartingView
  onViewChange: (view: ChartingView) => void
}

const ChartingViewToggle = ({
  currentView,
  onViewChange,
}: ChartingViewToggleProps): React.ReactElement => (
  <div className="charting-view-toggle" role="group" aria-label="Chart view">
    <div className="charting-toggle-group">
      {(
        [
          { view: 'upper' as const, label: 'Upper jaw', icon: ArchUpper },
          { view: 'full' as const, label: 'Full mouth', icon: ArchFull },
          { view: 'lower' as const, label: 'Lower jaw', icon: ArchLower },
        ] as const
      ).map(({ view, label, icon }) => (
        <button
          key={view}
          type="button"
          className={`charting-toggle-btn${currentView === view ? ' active' : ''}`}
          onClick={(): void => onViewChange(view)}
          title={label}
          aria-label={label}
          aria-pressed={currentView === view}
        >
          <img src={icon} alt="" className="charting-toggle-icon" />
        </button>
      ))}
    </div>
  </div>
)

export default ChartingViewToggle
